var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.303 38.8108C40.4086 38.5803 41.0671 37.4234 40.5177 36.4367C39.3066 34.2613 37.3985 32.3498 34.9577 30.8931C31.8141 29.0169 27.9624 28 24 28C20.0375 28 16.1858 29.0169 13.0422 30.893C10.6014 32.3498 8.69333 34.2613 7.48216 36.4366C6.93277 37.4234 7.59124 38.5803 8.69687 38.8108C18.7905 40.9143 29.2094 40.9143 39.303 38.8108Z",
    fill: "#FF0050"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 10,
    fill: "#FF0050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingUser);
export default __webpack_public_path__ + "static/media/SettingUser.f8f4304bbb36ca412c6f5f0c8180b6ca.svg";
export { ForwardRef as ReactComponent };